import { render, staticRenderFns } from "./CurriculumChipTeachingMaterialValue.vue?vue&type=template&id=3bf25b83&"
import script from "./CurriculumChipTeachingMaterialValue.vue?vue&type=script&lang=ts&"
export * from "./CurriculumChipTeachingMaterialValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports